import { render, staticRenderFns } from "./clueCompanyOwnerPage.vue?vue&type=template&id=c36ba9cc"
import script from "./clueCompanyOwnerPage.vue?vue&type=script&lang=js"
export * from "./clueCompanyOwnerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports